import script from "./BrandIntro.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandIntro.vue?vue&type=script&setup=true&lang=js"

import "./BrandIntro.vue?vue&type=style&index=0&id=395dba29&lang=css"

const __exports__ = script;

export default __exports__